import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import $ from "jquery";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react'; 
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from 'moment'; 

const OrderPayment = ({ show, onClose , order }) => {
   
    console.log('order' , order);


    const tableRef = useRef(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [endDate, setEndDate] = useState(new Date()); 
    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [isVisible, setIsVisible] = useState();
    const [payments, setPayments] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [listTotal, setListTotal] = useState(0);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [payAmount, setPayAmount] = useState('');
    const [validationError, setValidationError] = React.useState('');
    const [paymentScheduleDate, setPaymentScheduleDate] = useState(null);
    const [validationErrorDate, setValidationErrorDate] = useState('');
    const [collectedDate, setCollectedDate] = useState(null);
    const [dateError, setDateError] = useState(false);
 
    const handlePaymentModeChange = (selected) => {
        setSelectedOption(selected);
        setIsVisible(selected.value !== "6");
    };

    useEffect(() => {
        // Add 7 days to the current date
        const nextDate = new Date();
        nextDate.setDate(nextDate.getDate() + 7);
        setEndDate(nextDate);
    }, []);

        const fetchPayments = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/manage_order/payment_list_by_order/${order.id}`);
                if (response.data?.data && Array.isArray(response.data.data)) {
                    setPayments(response.data.data);
                } else {
                    setPayments([]);
                }
            } catch (error) {
                console.error('Failed to fetch payments:', error);
                setPayments([]);
            }
        };

        const calculateListTotal = (paymentsList) => {
            const total = paymentsList.reduce((acc, payment) => acc + (payment.amount || 0), 0);
            return total;
        };

        useEffect(() => {
            const total = calculateListTotal(payments);
            setListTotal(total);
        }, [payments]);


        const fetchCateringType = async () => {
            try {
                    const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
                    if (response.data && Array.isArray(response.data)) {
                        const formatted = response.data.map(item => ({
                            value: String(item.sno),
                            label: item.catering_type
                        }));
                        setCateringType(formatted);
                        console.log(formatted);
                    }
                } catch (error) {
                    console.error('Failed to fetch Catering Type:', error);
                    setCateringType([]);
                }
        };
    
        const getCateringTypeLabel = (sno) => {
            if (!Array.isArray(cateringType)) return '';
            const found = cateringType.find(ct => ct.value === String(sno));
            return found?.label || '';
        };
    
        const fetchitemSchedule = async () => {
                try {
                    const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
                    
                    const list = response.data?.data;
            
                    if (Array.isArray(list)) {
                    const formatted = list.map(item => ({
                        value: String(item.sno),
                        label: item.itemschedule_name
                    }));
                    setMealsPeriod(formatted);
                    } else {
                    setMealsPeriod([]); // fallback to empty array
                    }
                } catch (error) {
                    console.error('Failed to fetch Meals period:', error);
                    setMealsPeriod([]); // fallback to empty array, not object
                }
        };
    
        const getMealsPeriodLabel = (sno) => {
            if (!Array.isArray(mealsPeriod)) return '';
            const found = mealsPeriod.find(mp => mp.value === String(sno));
            return found?.label || '';
        };
    
        const fetchFunctionType = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                 const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.function_type
                    }));
                    setFunctionType(formatted);
                }
            } catch (error) {
                console.error('Failed to Function Type:', error);
                setFunctionType([]);
            }
        };
    
        const getFunctionTypeLabel = (sno) => {
            if (!Array.isArray(functionType)) return '';
            const found = functionType.find(ft => ft.value === String(sno));
            return found?.label || '';
        };
    
        const formatDate = (dateStr) => {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        };

        useEffect(() => {
                        fetchFunctionType();
                        fetchCateringType();
                        fetchitemSchedule();
        }, []);

        useEffect(() => {
            if (order?.id) {
                fetchPayments();
            }
        }, [order]);

        useEffect(() => {
            const tables = document.querySelectorAll('.subscription_table');
            tables.forEach((table) => {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            });
        }, []);

        const [showPaymentDetails, setShowPaymentDetails] = useState(false);
        const [sendVia, setSendVia] = useState('');

        const handleSendViaChange = (e) => {
            setSendVia(e.target.value);
        };

        const urldata = {
            order_id: selectedPayment?.payment_id,
            amount: selectedPayment?.amount
        };
        const encoded = btoa(JSON.stringify(urldata));

        const handleCreatePayment = async () => {
        const outstandingAmount = order.total - listTotal;
        const enteredAmount = parseFloat(payAmount);

        let hasError = false;

        if (!payAmount || isNaN(enteredAmount) || enteredAmount <= 0) {
            setValidationError('Enter a valid payment amount');
            hasError = true;
        } else {
            setValidationError('');
        }

        if (enteredAmount > outstandingAmount) {
            setValidationError('Not more than outstanding');
            hasError = true;
        } 

        if (!paymentScheduleDate) {
            setValidationErrorDate('Select a payment schedule date');
            hasError = true;
        } else {
            const today = new Date().toISOString().split('T')[0]; 

            if (paymentScheduleDate < today) {
                setValidationErrorDate('Payment schedule date cannot be in the past');
                hasError = true;
            } else {
                setValidationErrorDate('');
            }
        }



        // If any error, don't proceed
        if (hasError) return;

        try {
            const payload = {
            branch_id: branch_id,
            amount: Number(enteredAmount.toFixed(2)),
            customer_id: order.customer_id,
            order_id: order.id,
            order_total: order.total,
            payment_schedule_date: paymentScheduleDate.format
                ? paymentScheduleDate.format("YYYY-MM-DD")
                : paymentScheduleDate,
            balance_amount : outstandingAmount - enteredAmount,
            };

            const response = await axios.post(`${BaseUrl}/manage_order/create_payment`, payload);

            if (response.data?.success === true) {
            toast.success('Schedule created successfully');
            setPayAmount('');
            setPaymentScheduleDate(null);
            fetchPayments();
            } else {
            toast.error(response.data?.message || 'Failed to create');
            }
        } catch (error) {
            console.error('Error creating payment:', error);
            toast.error('Something went wrong while creating payment');
        }
        };

        const handleVerifyClick = () => {
            if (!collectedDate) {
                setDateError(true); // ✅ show validation error
                return;
            }

            setDateError(false); // ✅ clear error on valid input

            // ✅ Call async handler and pass modal close callback
            HandleVerify(order, selectedPayment || '', collectedDate, onClose);
        };
 
        const HandleVerify = async (order, payment, date, onClose) => {
            try {
                const response = await axios.post(`${BaseUrl}/manage_order/handle_verify`, {
                    order: order,
                    payment: payment,
                    date: date ? date.format('YYYY-MM-DD') : null,
                });

                if (response.data?.success) {
                    toast.success(response.data.message || 'Payment verified successfully!');
                    
                    if (typeof onClose === 'function') {
                        onClose(); // ✅ Close modal on success
                    }
                } else {
                    toast.error(response.data.message || 'Verification failed');
                }
            } catch (error) {
                toast.error(
                    error.response?.data?.message || 'An error occurred during verification'
                );
                console.error('Failed to verify payment:', error);
            }
        };
 
        return (
            <Modal show={show} size="lg"  >
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                        <h3 className="modal-title text-white">Order Payment</h3>
                        <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                            <span className="text-white">×</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className="row mb-4">
                        <div className="row mb-4">
                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Order Id</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{order.catering_id}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Customer Name</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{order?.customer?.customer_name}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Customer Mobile No</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{order?.customer?.customer_number}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Catering Type</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{getCateringTypeLabel(order?.catering_type)}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Function Type</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{getFunctionTypeLabel(order?.function_type)}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Total Cost</label>
                                <label className='text-danger font-w600 fs-6 py-0'>₹ {parseFloat(order?.total || 0).toLocaleString()}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Head Count</label>
                                <label className='text-white bg-primary px-2 rounded font-w600 fs-6 py-1'>{order?.head_count}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Payment Closing Date</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{formatDate(order?.payment_closing_date)}</label>
                            </div>

                            <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                                <label className='text-black text-start font-w600 fs-7'>Order Delivery Date</label>
                                <label className='text-danger font-w600 fs-6 py-0'>{formatDate(order.order_date)}</label>
                            </div>
                            </div>

                        </div>
                        <div className="row mb-3">
                            <div className='col-lg-12 mb-4'>
                                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-100px'>Payment Amount </th>
                                            <th className='min-w-100px'>Schedule Date</th>
                                            <th className='min-w-80px'>Payment Date</th>
                                            <th className='min-w-80px'>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                    {payments.length > 0 ? (
                                        payments.map((payment, index) => (
                                        <tr key={payment.sno}>
                                            <td>
                                                <label className='text-black font-w600 fs-7'>₹ {payment.amount.toLocaleString()}</label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w600 fs-7'>
                                                    {payment.payment_schedule_date ? formatDate(payment.payment_schedule_date) : '-'}
                                                </label>
                                            </td>
                                            <td>
                                                <label className='text-black font-w600 fs-7'>
                                                    {payment.initialPayDate ? formatDate(payment.initialPayDate) : '-'}
                                                </label> 
                                            </td>
                                            <td>
                                                {payment.status == 0 ? (
                                                <label
                                                    className="text-white font-w600 fs-7 bg-primary py-1 px-2 rounded"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                    setSelectedPayment(payment);
                                                    setShowPaymentDetails(true);
                                                    }}
                                                >
                                                    Pay
                                                </label>
                                                ) : payment.status == 1 ? (
                                                <label className="text-white font-w600 fs-7 bg-success py-1 px-2 rounded">
                                                    Paid
                                                </label>
                                                ) : payment.status == 2 ? (
                                                <label className="text-white font-w600 fs-7 bg-warning py-1 px-2 rounded">
                                                    Verification Pending
                                                </label>
                                                ) : null /* or fallback */}
                                            </td>
                                        </tr>
                                        ))
                                    ) : (
                                        <tr>
                                        <td colSpan="4" className="text-center">No payment records found</td>
                                        </tr>
                                    )}
                                    </tbody>

                                </table>
                            </div>

                            {(order.total - listTotal) > 0 && (
                            <div className="col-lg-12 mb-4">
                                <div className="col-lg- rounded p-3 bg-light">
                                <h5 className="mb-3 text-black">Make Partial Payment</h5>

                                <div className="row g-3">

                                    {/* Outstanding Amount */}
                                    <div className="col-md-3">
                                    <label className="form-label fw-bold text-black">Outstanding Amount</label>
                                    <input
                                        type="number"
                                        className="form-control text-black"
                                        value={order.total - listTotal}
                                        disabled
                                    />
                                    <div style={{ height: "1.25rem", marginTop: "0.25rem" }}></div>
                                    </div>

                                    {/* Partial Payment Amount */}
                                    <div className="col-md-3">
                                    <label className="form-label fw-bold text-black">Payment Amount</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control text-black"
                                        max={order.total - listTotal}
                                        value={payAmount}
                                        onChange={(e) => setPayAmount(e.target.value)}
                                        placeholder={`Max: ₹ ${order.total - listTotal}`}
                                    />
                                    <div
                                        style={{
                                        height: "1.25rem",
                                        marginTop: "0.25rem",
                                        color: "red",
                                        fontSize: "0.600",
                                        }}
                                    >
                                        {validationError || "\u00A0"}
                                    </div>
                                    </div>

                                    {/* Payment Schedule Date */}
                                    <div className="col-md-3">
                                    <label className="form-label fw-bold text-black">Payment Schedule Date<span className="required">*</span></label>
                                    <div className="d-flex align-items-center border rounded">
                                        <div className="input-group-text bg-transparent border-0 px-0">
                                        <i className="fa-solid fa-calendar-days fs-5 text-muted"></i>
                                        </div>
                                        <DatePicker
                                        placeholder="Select Date"
                                        value={paymentScheduleDate}
                                        onChange={setPaymentScheduleDate}
                                        format="DD-MM-YYYY"
                                        className="form-control text-black ms-2"
                                        style={{ boxShadow: "none" }}
                                        position="right"  
                                        minDate={new Date()}  
                                        />
                                    </div>
                                    <div
                                        style={{
                                        height: "1.25rem",
                                        marginTop: "0.25rem",
                                        color: "red",
                                        fontSize: "0.700rem",
                                        }}
                                    >
                                        {validationErrorDate || "\u00A0"}
                                    </div>
                                    </div>

                                    {/* Create Payment Button */}
                                    <div className="col-md-3 d-flex flex-column justify-content-end">
                                    <button
                                        className="btn btn-primary fs-7 w-100"
                                        onClick={handleCreatePayment} 
                                    >
                                        Create Payment
                                    </button>
                                    <div style={{ height: "1.25rem", marginTop: "0.25rem" }}></div>
                                    </div>

                                </div>
                                </div>
                            </div>
                            )}


        
                            {showPaymentDetails && (
                            <>
                                <div className='col-lg-12 mb-2'>
                                    <div className='text-center mb-4'>
                                        <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                            <label className='mb-0'>Payments Details</label>
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-lg-6 mb-2'>
                                            <div className='row mb-2'>
                                                {/* Radio Buttons */}
                                                <div className="col-lg-12 mb-4">
                                                    <label className="text-black font-w500 fs-5">Send Via Whatsapp<span className="required">*</span></label>
                                                    <div className='mt-2'>
                                                        <div className="form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="send_via"
                                                                value="online"
                                                                checked={sendVia === 'online'}
                                                                onChange={handleSendViaChange}
                                                            />
                                                            <label className="form-check-label fs-7 font-w600 text-black">Online</label>
                                                        </div>
                                                        <div className="form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="send_via"
                                                                value="offline"
                                                                checked={sendVia === 'offline'}
                                                                onChange={handleSendViaChange}
                                                            />
                                                            <label className="form-check-label fs-7 font-w600 text-black">Offline</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                {sendVia === 'online' && (
                                                    <div className='col-lg-12 mb-2'>
                                                        <OverlayTrigger
                                                        trigger="['hover','trigger']"
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip className='toltip-popover'>
                                                            <span className='fs-8 text-white fw-semibold'>Send Payment Link</span>
                                                            </Tooltip>
                                                        }
                                                        >
                                                        <Link
                                                            to={`/online-payment?data=${encodeURIComponent(encoded)}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >   
                                                            <div className='col-lg-12 mb-2 text-center'>
                                                                <QRCodeSVG
                                                                value={`${window.location.origin}/online-payment?data=${encodeURIComponent(encoded)}`}
                                                                size={200}
                                                                bgColor="#ffffff"
                                                                fgColor="#000000"
                                                                level="H"
                                                                includeMargin={true}
                                                                />
                                                            </div>
                                                            <div className='d-flex align-items-center gap-2 rounded py-1 px-2' style={{ backgroundColor: '#dafcc7ff' }}>
                                                            <i className="fa-solid fa-link text-primary fs-4"></i>
                                                            <label className='text-primary font-w600 fs-5 ms-1'>Link attached</label>
                                                            </div>
                                                        </Link>
                                                        </OverlayTrigger>
                                                    </div>
                                                    )}

                                                    {sendVia === 'offline' && (
                                                        <div className="col-lg-12 mb-2">
                                                            <div className="d-flex align-items-center gap-4"> 
                                                            <div style={{ maxWidth: '150px', flexGrow: 0 }}>
                                                                <label
                                                                htmlFor="cashInput"
                                                                className="form-label fw-bold text-black"
                                                                style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}
                                                                >
                                                                Collected Cash
                                                                </label>
                                                                <input
                                                                type="number"
                                                                id="cashInput"
                                                                className="form-control text-black"
                                                                value={selectedPayment ? selectedPayment.amount : 0}
                                                                readOnly
                                                                />
                                                            </div>
 
                                                            <div style={{ maxWidth: '250px', flexGrow: 1 }}>
                                                                <label
                                                                htmlFor="collectedDate"
                                                                className="form-label fw-bold text-black"
                                                                style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}
                                                                >
                                                                Collected Date
                                                                </label>
                                                                <div className="d-flex align-items-center border rounded">
                                                                <div className="input-group-text bg-transparent border-0 px-2">
                                                                    <i className="fa-solid fa-calendar-days fs-5 text-muted"></i>
                                                                </div>
                                                                <DatePicker
                                                                    id="collectedDate"
                                                                    placeholder="Select Date"
                                                                    value={collectedDate}
                                                                    onChange={setCollectedDate}
                                                                    format="DD-MM-YYYY"
                                                                    className="form-control text-black ms-2"
                                                                    style={{ boxShadow: 'none' }}
                                                                    position="right"
                                                                    maxDate={new Date()} 
                                                                />
                                                                </div>
                                                                 {dateError && (
                                                                    <div className="text-danger mt-1" style={{ fontSize: '0.8rem' }}>
                                                                        Please select a collected date.
                                                                    </div>
                                                                )}
                                                            </div>
                                                            </div>  
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                        <div className='col-lg-6 mb-2'>
                                            <div className='row mb-2'>
                                    
                                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                    <div className='text-black font-w500 fs-4'>Sub Total</div>
                                                    <div>
                                                        <label className='text-black font-w500 fs-3'>
                                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                            <span>{selectedPayment?.amount}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                           
                                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                    <label className='text-black font-w500 fs-3'>Total Amount</label>
                                                    <div>
                                                        <label className='text-danger fw-bold fs-2'>
                                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                            <span>{selectedPayment ? selectedPayment.amount : 0}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            )}
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            {sendVia === 'online' && (
                            <Link className="btn btn-sm btn-primary" onClick={onClose}>Send Order Payment <i className="fas fa-angle-double-right ms-2"></i></Link>
                            )}
                            {sendVia === 'offline' && (
                            <Link className="btn btn-sm btn-primary" onClick={() => handleVerifyClick()}>Verify Payment <i className="fas fa-angle-double-right ms-2"></i></Link>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
        );
};

export default OrderPayment;
